import { DONATION_ROUTES } from '@/constants';

export const GOODS_GIFT_LIST_HREF = DONATION_ROUTES.GIFTS.withSearchParams({
  searchParams: { editionOnly: true },
});

export const FINANCE_BENEFIT_SECTION_ID = 'finance-benefits';
